//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContentHeader from 'components/ContentHeader'
import Vue from 'vue'
import $ from 'jquery'
import DateRangePicker from 'components/DateRangePicker'

const Pagination = require('../plugins/vue-bootstrap-paginator').default

export default {
  components: {
    ContentHeader,
    Pagination,
    DateRangePicker
  },
  data () {
    return {
      searchTransactionId: '',
      searchPayStatus: '',
      searchOrderStatus: '',
      searchShippingStatus: '',
      searchDate: {startDate: '', endDate: '', startDateText: '', endDateText: ''},
      dateOptions: JSON.parse(JSON.stringify(this.dateRangePickerOptions)),
      singleDateOptions: JSON.parse(JSON.stringify(this.dateTimePickerOptions)),
      deo: {},
      deoDate: {startDate: '', startDateText: ''},
      searchSum: 2,
      orderList: [],
      totalItems: 0,
      currentPage: 1,
      perPage: 0,
      appointPage: 1,
      lastPage: 0,
      shipList: []
    }
  },
  created () {
  },
  mounted () {
    // 获取物流公司列表
    let $this = this
    Vue.http.get(this.serviceUrl('api/shipping/list'), {params: {search_type: 'all'}}).then((resp) => {
      $this.shipList = resp.data.shipList;
    })
    // 检测是否有指定参数
    let transactionID = this.$route.params.transaction_id;
    if (transactionID) {
      this.searchTransactionId = transactionID;
      this.getOrderList(1);
    } else {
      this.getOrderList()
    }
  },
  computed: {
  },
  methods: {
    // 获取订单列表
    getOrderList: function (page = 1) {
      let $this = this
      var params = {
        page: page,
        transaction_id: this.searchTransactionId,
        pay_status: this.searchPayStatus,
        order_status: this.searchOrderStatus,
        shipping_status: this.searchShippingStatus,
        pay_type: this.searchPayType,
        sdate: this.searchDate.startDateText,
        edate: this.searchDate.endDateText,
        sum: this.searchSum
      }
      Vue.http.get(this.serviceUrl('api/shop/order/list'), {params: params}).then((response) => {
        let resp = response.data
        $this.orderList = resp.orderList.data;
        $this.totalItems = resp.orderList.total;
        $this.currentPage = resp.orderList.current_page;
        $this.perPage = resp.orderList.per_page;
        $this.lastPage = resp.orderList.last_page;
        $this.totalCost = resp.total_cost;
        $this.totalFee = resp.total_fee;
        $this.totalOriginPrice = resp.total_origin_price;
      })
    },
    // 分页跳转
    pageChanged: function (page = 1) {
      this.getOrderList(page);
    },
    // 跳转指定页面
    pageJumped: function () {
      let appointPage = parseInt(this.appointPage) < this.lastPage ? parseInt(this.appointPage) : this.lastPage;
      this.getOrderList(appointPage);
    },
    showDeliveryModel: function (row) {
      let self = this;
      self.deo = row;
      if (row.order_address && row.order_address.delivery_date) {
        if (self.deoDate.startDate) {
          self.deoDate = {startDate: row.order_address.delivery_date, startDateText: row.order_address.delivery_date};
        } else {
          setTimeout(function () {
            self.deoDate = {startDate: row.order_address.delivery_date, startDateText: row.order_address.delivery_date};
          }, 1000);
        }
      }
    },
    saveOrderAddress: function (addr) {
      let self = this;
      addr.delivery_date = this.deoDate.startDateText;
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/shop/order/address/' + addr.shop_order_id),
        data: addr
      }).then(function (response) {
        let resp = response.data
        if (resp.errcode === 0) {
          self.alert('保存成功', 1);
        } else {
          self.alert(resp.errmsg, 2);
        }
      });
    },
    deoFeeOnChange: function (addr) {
      if (!addr.shipping_fee) {
        addr.shipping_fee = 0;
      }
    },
    saveOrder: function (order) {
      let self = this;
      Vue.http({
        method: 'PUT',
        url: this.serviceUrl('api/shop/order/' + order.shop_order_id),
        data: order
      }).then(function (response) {
        let resp = response.data
        if (resp.errcode === 0) {
          self.alert('保存成功', 1);
        } else {
          self.alert(resp.errmsg, 2);
        }
      });
    },
    changeOrderStatus: function (order, status) {
      order.order_status = status;
      this.saveOrder(order);
    },
    changeOrderShippingStatus: function (order, status) {
      order.shipping_status = status;
      this.saveOrder(order);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/PageShopOrderList.vue